import React from 'react';
import './App.css';
import CallApp from 'callapp-lib';

function getOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

const Thank = () => {
  let options = {
    scheme: {protocol: 'elehearapp'},
    appstore: 'https://apps.apple.com/cn/app/elehear/id6446886717',
    fallback: 'https://apps.apple.com/cn/app/elehear/id6446886717'
  };

  if(getOS() === 'Android'){
    options = {
      scheme: {protocol: 'elehearapp'},
      appstore: 'https://play.google.com/store/apps/details?id=netinfo.jp.elehear',
      fallback: 'https://play.google.com/store/apps/details?id=netinfo.jp.elehear'
    };
  }

  const callLib = new CallApp(options);
  
  const handleClickBackApp = () => {
    callLib.open({
      path: 'elehearapp://',
    });
  };

  return (
    <div >
    <div className='div-grey-container-center  div-mid-text-top div-margin-top-1'>
      Help Us Improve
      
    </div>
    <div className="footer-placeholder"></div>
    <div className="footer-placeholder"></div>
    <div className="footer-placeholder"></div>
    
    <div className="container-white">
      <div className='div-grey-container-center div-margin-top-60'>
        <button /* onClick={handleClickBackApp} */  className='ok-btn'></button>
      
      </div>

      <div className='div-grey-container-center div-margin-top-60 div-mid-text'>
      Thank you for your participation!
      
      </div>

      <div className='div-grey-container-center div-margin-top-10 thank-text-small'>
        Your feedback is incredibly important to us. It plays a key role in helping us improve and deliver better products.
      </div>
    </div>
    </div>
  );
};

export default Thank;
